import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppMode } from '@/store/app-mode';

const SHARED_ROUTES = ['/settings', '/notifications'];

export const useModeSyncWithUrl = () => {
  const location = useLocation();
  const { mode, setMode } = useAppMode();

  useEffect(() => {
    const isAgentForgeRoute = location.pathname.startsWith('/forge');
    const isSharedRoute = SHARED_ROUTES.some((r) =>
      location.pathname.startsWith(r)
    );

    if (isSharedRoute) return;

    if (isAgentForgeRoute && mode !== 'agentforge') {
      setMode('agentforge');
    } else if (!isAgentForgeRoute && mode === 'agentforge') {
      setMode('recruit');
    }
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps
};
